import React, { useContext, useEffect, useState, useCallback, useMemo } from "react";
import "./styles.css";
import { Breadcrumb, SuccessPopupModal, Title } from "../../Components/Atoms";
import PATHS from "../../Routes/paths";
import { useNavigate, useSearchParams } from "react-router-dom";
import { StoreContext } from "../../Library/contexts";
import { getUserAndVehicleDetails, manageVehicles } from "../../APIs";
import { ReactTable } from "../../Components/Molecules";
import { SUBUSER_ASSIGN_VEHICLE_HEADERS } from "../../Library/tableHeaders";
import { Button, useToast } from "@chakra-ui/react";

const AssignVehsToSubusers = () => {
  const [ searchParams ] = useSearchParams();
  const { allSubUsers, setAllSubUsers, userVehicles, setUserVehicles } = useContext(StoreContext);
  const [ selectedSubUser, setSelectedSubUser ] = useState(null);
  const [ selectedRows, setSelectedRows ] = useState([]);
  const [ modalMsg, setModalMsg ] = useState("");
  const navigate = useNavigate();
  const Toast = useToast();

  const breadcrumbPaths = [
    { idx: 1, name: "Subusers", link: PATHS.SUB_USERS },
    { idx: 2, name: `${(selectedSubUser && selectedSubUser.fn) || "Sub user"}`, link: `${PATHS.SUB_USERS}/${PATHS.SUB_USER_DETS}?mob=${searchParams.get("mob")}` },
    { idx: 3, name: "Assign Vehicles", isCurrentPage: true },
  ];

  const handleSelectedSubUser = (subUsers) => {
    let mob = +searchParams.get("mob");
    if (mob) {
      let userToShow = (subUsers || allSubUsers).find(user => user.mob === mob);
      if (userToShow && userToShow.mob) setSelectedSubUser(userToShow);
    } else navigate(PATHS.SUB_USERS);
  }

  useEffect(() => {
    if (allSubUsers && allSubUsers.length) {
      handleSelectedSubUser();
    } else {
      getUserAndVehicleDetails({}, (err, data=[]) => {
        if (err) console.error("Error fetching sub users");
        else {
          setAllSubUsers(data);
          handleSelectedSubUser(data);
        }
      });
    }
  }, [ allSubUsers, setAllSubUsers ]);

  const columns = React.useMemo(() => Object.values(SUBUSER_ASSIGN_VEHICLE_HEADERS).map(header => {
    return {
      Header: header.nm,
      accessor: header.key,
      disableSortBy: !header.sorting,
      Cell: (row) => row.value || "-",
    };
  }), []);

  const unassignedVehicles = useMemo(
    () => userVehicles.filter((veh) => !veh.subUsers || veh.subUsers.length === 0),
    [userVehicles]
  );

  const handleVehicleAssign = () => {
    if (!selectedSubUser || !selectedSubUser.idx) return;
    let vids = selectedRows.map(row => row && row.original && row.original.idx);
    manageVehicles({ vids, isAssign: true, uid: selectedSubUser.idx }, (err, success) => {
      if (err) Toast({ isClosable: true, description: `${err} Please try again later!`, position: "bottom", variant: "subtle", duration: 3000 });
      else {
        let updatedData = userVehicles.map((veh) => {
          if (vids.includes(veh.idx)) {
            return {
              ...veh,
              subUsers: [...(veh.subUsers ? veh.subUsers : []), selectedSubUser.idx],
            };
          }
          return veh;
        });
        setUserVehicles(updatedData);
        setModalMsg("Vehicles assigned successfully!");
      }
    });
  }

  return (
    <div className="panel-main assign-vehs-to-subusers">
      <div className="assign-vehs-header">
        <Breadcrumb paths={breadcrumbPaths} />
      </div>

      <div className="subuser-assign-vehs-table-container">
        <Title>Unassigned Vehicles</Title>
        <ReactTable onRowSelect={(_, rows) => setSelectedRows(rows)} showSelection={true} data={unassignedVehicles} columns={columns} showSearch pageSize={8} showSelectAll={false} />
      </div>
      <div className="assign-vehs-btn-container">
        <Button onClick={handleVehicleAssign} disabled={!selectedRows.length} className={`assign-vehs-btn ${!selectedRows.length ? "disabled-bg" : ""}`}>{`Assign ${selectedRows.length || ""} vehicles`}</Button>
      </div>

      <SuccessPopupModal
        open={!!modalMsg}
        modalMsg={modalMsg}
        closeBtn={"Okay"}
        modalSize={"lg"}
        onModalClose={() => { navigate(`${PATHS.SUB_USERS}/${PATHS.SUB_USER_DETS}?fromAssignVehs=1`) }}
      />
    </div>
  )
}

export default AssignVehsToSubusers
